<template>
  <!-- 提示弹窗 -->
  <van-dialog v-model:show="isPrompt" :showConfirmButton="false">
    <div class="dialog">
      <div class="title">
        <div>{{ $t("提示") }}</div>
        <img @click="hide" src="@/assets/icons/ic_Close@2x.png" alt="" />
      </div>
      <div class="text">
        <div>{{ content }}</div>
      </div>
      <div class="pay-btn">
        <div class="Confirm" @click="handleConfirm">
          {{ confirmText ? confirmText : $t("確認") }}
        </div>
        <div class="Cancel" @click="hide">
          {{ cancelText ? cancelText : $t("取消") }}
        </div>
      </div>
    </div>
  </van-dialog>

</template>
<script>
import mixins from "@/utils/mixins.js"
export default {
  name: "promptDialog",
  mixins: [mixins],
  props: {
    content: {
      type: String,
      default: ""
    },
    confirmText: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      isPrompt: false,
    }
  },
  methods: {
    open (data) {
      this.isPrompt = true
    },
    hide () {
      this.isPrompt = false
    },
    handleConfirm () {
      this.$emit('success')
      this.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  padding: 24px;

  .text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #1a1a1a;
    text-align: center;

    span {
      color: #3491fa;
    }
  }

  .pay-btn {

    .Cancel,
    .Confirm {
      flex: 1;
      text-align: center;
      margin-top: 10px;
    }

    .Cancel {
      background: #eeeeee;
      border-radius: 12px 12px 12px 12px;
      padding: 8px;
    }

    .Confirm {
      font-size: 16px;
      color: #ffffff;
      background-color: #90d12e;
      border-radius: 12px 12px 12px 12px;
      padding: 8px;
    }
  }

  .title {
    text-align: center;
    margin-bottom: 12px;
    font-weight: 500;

    div {
      text-align: center;
    }

    img {
      width: 24px;
      position: absolute;
      right: 16px;
      top: 16px;
    }
  }
}
</style>